import React from 'react';
import { Provider } from 'react-redux';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';

import firebase from './firebase';
import createStore from './store';

/**
 * React redux firebase options
 */
const rrfConfig = {
  enableLogging: false // enable/disable Firebase's database logging
};

/**
 * Wrapper for the app's various root level providers
 */
const Providers = ({ children }) => {
  const store = createStore();
  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider
        config={rrfConfig}
        dispatch={store.dispatch}
        firebase={typeof window !== 'undefined' ? firebase : {}}
      >
        {children}
      </ReactReduxFirebaseProvider>
    </Provider>
  );
};

export default Providers;
